import { render, staticRenderFns } from "./finRiskWarnings.vue?vue&type=template&id=7cd2cbf5&"
import script from "./finRiskWarnings.vue?vue&type=script&lang=js&"
export * from "./finRiskWarnings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports